import { phoneMask } from "../utils/masks";

const phoneInput = document.getElementById("phone");
phoneMask(phoneInput);
